var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading-mask bg-red"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-loading-container"},[_c('div',{staticClass:"circle-loading"}),_c('p',[_vm._v("LOADING...")])])
}]

export { render, staticRenderFns }